<template>
    <div class="section-job" :class="color">
        <layout-contained :class="padding">
            <content-heading
                v-if="heading"
                :heading="heading"
                :headingColor="headingColor"
                :headingComponent="headingComponent"
                :marginBottom="content ? 'mb-6' : 'mb-0'"
                :textCentered="textCentered"
            ></content-heading>
            <p v-if="job.job_type"><strong>Type:</strong> {{ job.job_type }}</p>
            <p v-if="job.job_location"><strong>Location:</strong> {{ job.job_location }}</p>
            <p v-if="job.job_salary"><strong>Salary:</strong> {{ job.job_salary }}</p>
            <p v-if="job.job_location"><strong>Start Date:</strong> {{ job.job_location }}</p>
            <content-text
                v-if="content"
                class="mt-8"
                :html="content"
                :contentColor="contentColor"
                :textCentered="textCentered"
            ></content-text>
            <slot name="custom"></slot>
        </layout-contained>
    </div>
</template>

<script>
export default {
    name: 'SectionJob',
    props: {
        job: {
            required: true,
            type: Object,
            default() {
                return {};
            },
        },
        padding: {
            required: false,
            default: 'py-12 sm:py-14',
            type: String,
        },
        color: {
            required: false,
            type: String,
            default: null,
        },
        contentColor: {
            required: false,
            type: String,
            default: 'text-gray-600',
        },
        headingColor: {
            required: false,
            type: String,
            default: 'text-gray-900',
        },
        headingComponent: {
            required: false,
            type: String,
            default: 'h1',
        },
        textCentered: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
    },
    computed: {
        heading() {
            return this.job.job_title;
        },
        content() {
            return this.job.job_description;
        },
    },
};
</script>
